import React, {Component} from 'react';

class Logo extends Component {
    render() {
        return (

            <a className="home-link" href={process.env.PUBLIC_URL + '/'} title="Nana Udyog" rel="home">
                <img id="logo-img" height="90" width="90" className="img-fluid auto_size" src={process.env.PUBLIC_URL+"/images/logo.png"} alt="logo-img"/>
             </a>
        );
    }
}

export default Logo;